<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        layout=""
        :model="formInline"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="12"> 基本信息 </a-col>
        </a-row>
        <a-divider />
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="财务编号">
              <a-input v-model="formInline.user" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="结算、落地单号">
              <a-input v-model="details.financeNo" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="财务类型">
              <a-input v-model="details.financeType" placeholder="用户提现">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="用户名称">
              <a-input v-model="details.addressName" placeholder="海珠">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="收支类型">
              <a-input v-model="formInline.user" placeholder="开支"> </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="财务状态">
              <a-input v-model="details.financeStatusStr" placeholder="待处理">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="交易方式">
              <a-input v-model="details.payMethod" placeholder="支付宝">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="交易账号">
              <a-input v-model="details.payAccount" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="交易名称">
              <a-input v-model="details.payName" placeholder="支付宝">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="归属地">
              <a-input v-model="formInline.user" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="操作管理员">
              <a-input v-model="details.adminName" placeholder="支付宝">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="交易凭证">
              <a-input v-model="formInline.user" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <a-table :columns="columns" :data-source="data" v-if="show"> </a-table>
    </div>
    <!--  -->
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        layout=""
        :model="formInline"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="12"> 金额信息 </a-col>
        </a-row>
        <a-divider />
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="提交金额">
              <a-input v-model="details.moneyChange" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="打款金额">
              <a-input v-model="formInline.user" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="佣金金额">
              <a-input v-model="details.moneyRate" placeholder="用户提现">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="佣金率">
              <a-input v-model="details.rate" placeholder="海珠"> </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="第三方交易号">
              <a-input v-model="details.thirdTradeNo" placeholder="开支">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="第三方交易状态">
              <a-input v-model="details.thirdTradeStatus" placeholder="待处理">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <!-- <a-table :columns="columns" :data-source="data" v-if="show"> </a-table> -->
    </div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        layout=""
        :model="formInline"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="12"> 提现方式 </a-col>
        </a-row>
        <a-divider />
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="提现方式">
              <a-input v-model="formInline.user" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="支付宝账号">
              <a-input v-model="formInline.user" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="支付宝实名">
              <a-input v-model="formInline.user" placeholder="用户提现">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <a-table :columns="columns" :data-source="data" v-if="show"> </a-table>
    </div>
    <a-button
      type="primary"
      :style="{
        margin: '0px 16px 24px 16px',
      }"
    >
      返回
    </a-button>
  </div>
</template>

<script>
import { withdrawaDetailslList } from "@/api/orderApi.js";
const columns = [
  {
    title: "Age",

    dataIndex: "name",
    key: "name",
    slots: { title: "customTitle" },
    scopedSlots: { customRender: "name" },
  },
  {
    title: "Age",
    dataIndex: "age",
    key: "age",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Tags",
    key: "tags",
    dataIndex: "tags",
    scopedSlots: { customRender: "tags" },
  },
  {
    title: "Action",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

const data = [
  {
    key: "1",
    name: "John Brown",
    age: 32,
    address: "New York No. 1 Lake Park",
    tags: ["nice", "developer"],
  },
];
// import chooseAnItem from "./chooseAnItem.vue";
export default {
  components: {
    // chooseAnItem,
  },
  data() {
    return {
      details: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      formInline: {
        user: "",
        password: "",
      },
      data,
      columns,
      show: false,
    };
  },
  created() {
    this.getWithdrawaDetailslList();
  },
  methods: {
    getWithdrawaDetailslList() {
      let objId = this.$route.query.objId;
      withdrawaDetailslList(objId).then((res) => {
        this.details = res.data;
        console.log(res);
      });
    },
    onChange(date, dateString) {
      console.log(date, dateString);
    },
    showtable(show) {
      this.show = show;
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/financialManagement/withdrawalAudit/withdrawalDetails/withdrawalDetails.vue